// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad73e9c4","622":"e75cba05"}[chunkId] + ".chunk.js";
};